import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import usePersonnelFile from '../../../components/personnel-file/usePersonnelFile';
import PersonnelFileView from '../../../components/personnel-file/PersonnelFileView';
import DocumentViewerModal from '../../../components/ui/DocumentViewerModal';

export default function EmployeePersonnelFileTab({ employeeId }) {
  const { t } = useTranslation();
  const { fetching, file } = usePersonnelFile(employeeId);
  // { fileUrl, title } | null — açık olduğunda DocumentViewerModal'ı besler.
  const [viewing, setViewing] = useState(null);

  return (
    <>
      <PersonnelFileView
        items={file?.items}
        fetching={fetching}
        onOpenFile={(item) => setViewing({
          fileUrl: item.fileUrl,
          title: t(`personnelFile.type.${item.documentType}`, { defaultValue: item.title }),
        })}
      />
      <DocumentViewerModal
        open={!!viewing}
        fileUrl={viewing?.fileUrl}
        title={viewing?.title}
        onClose={() => setViewing(null)}
      />
    </>
  );
}
